import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Identity16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 5.25C9.2255 5.25 10.25 6.2745 10.25 7.5C10.25 8.17642 9.93549 8.82874 9.41421 9.25001L10 9.25001C10.9665 9.25001 11.75 10.0335 11.75 11V12H10.25V11C10.25 10.8619 10.1381 10.75 10 10.75L6 10.75C5.86193 10.75 5.75 10.8619 5.75 11V12H4.25V11C4.25 10.0335 5.0335 9.25 6.00001 9.25L6.58578 9.25C6.06451 8.82873 5.75 8.17642 5.75 7.5C5.75 6.2745 6.7745 5.25 8 5.25ZM8 6.75C7.60218 6.75 7.25 7.10218 7.25 7.5C7.25 7.89782 7.60218 8.25 8 8.25C8.39782 8.25 8.75 7.89782 8.75 7.5C8.75 7.10218 8.39782 6.75 8 6.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.225 1.25H13.5C14.1904 1.25 14.75 1.80964 14.75 2.5V14C14.75 14.6904 14.1904 15.25 13.5 15.25H2.5C1.80964 15.25 1.25 14.6904 1.25 14V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H4.775C4.89082 0.67944 5.39526 0.25 6 0.25H10C10.6047 0.25 11.1092 0.67944 11.225 1.25ZM4.75 2.75H2.75V13.75H13.25V2.75H11.25V3C11.25 3.69036 10.6904 4.25 10 4.25H6C5.30964 4.25 4.75 3.69036 4.75 3V2.75ZM6.25 2.75V1.75H9.75V2.75H6.25Z'
      fill='currentColor'
    />
  </Svg>
);

Identity16.displayName = 'Identity16';
export default Identity16;
